/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forgettingstarted2Inputs */

const en_forgettingstarted2 = /** @type {(inputs: Forgettingstarted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For getting started`)
};

const de_forgettingstarted2 = /** @type {(inputs: Forgettingstarted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für den Einstieg`)
};

/**
* | output |
* | --- |
* | "For getting started" |
*
* @param {Forgettingstarted2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const forgettingstarted2 = /** @type {((inputs?: Forgettingstarted2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forgettingstarted2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forgettingstarted2(inputs)
	return de_forgettingstarted2(inputs)
});
export { forgettingstarted2 as "forGettingStarted" }